import { UndoType } from '@databases/analytics/src/types';

import { unreachable } from './importHelper';

export type PasteMessageType =
  | UndoType
  | 'cannotReadPastedContent'
  | 'unexpectedDataType';

export const getPasteMessageByType = (type: PasteMessageType) => {
  switch (type) {
    case 'replaceExistingContent':
      return 'snackbar-warning.pasting-over-existing-content';
    case 'mismatchedFieldType':
      return 'snackbar-warning.pasting-content-that-doesnt-match';
    case 'updateFieldSettings':
      return 'snackbar-warning.field-settings-updated';
    case 'successfulImport':
      return 'snackbar-success-message.imported-successfully';
    case 'cannotReadPastedContent':
      return 'snackbar-error-message.cannot-read-pasted-content';
    case 'unexpectedDataType':
      return 'snackbar-error-message.unexpected-data-type';
    default:
      return unreachable(type);
  }
};
